{
	"title": "{{plant}} {{year}} – Adjust carbon buffer settings",
	"description": "You can change the carbon buffer value (%), but the change will take effect from the next cycle. You can add a reason for the change, which will be visible in the change log below.",
	"currentBufferTitle": "Current carbon buffer settings",
	"buffer": "Carbon buffer setting",
	"decreaseValue": "Decrease {{field}}",
	"increaseValue": "Increase {{field}}",
	"reasonForAdjustment": "Reason for adjustment",
	"reasonHint": "Please describe the reason for the adjustment.",
	"changeLogTitle": "Carbon buffer settings – change log ({{year}})",
	"editor": "Editor",
	"warning": "During the annual assurance process, the assurance body will review all balance adjustments. Prior to making any adjustments, it is mandatory to contact the assurance body to discuss the proposed changes.",
	"closeWarning": "Close warning",
	"confirmLabel": "I confirm the carbon buffer settings adjustment.",
	"footerHint": "Change the carbon buffer settings, fill in the reason, and toggle confirmation to adjust the buffer volume.",
	"cancel": "Cancel",
	"submit": "Adjust carbon buffer settings",
	"fetchError": "Could not load the carbon buffer settings. Please try again.",
	"submitSuccess": "Carbon buffer settings adjusted successfully.",
	"submitError": "Could not adjust the carbon buffer settings. Please try again."
}
